export default "__VITE_ASSET__BYUXTaW5__"